import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I've hit a glass ceiling of coding productivity. Now what?",
  "description": "",
  "published": "2012-08-30T00:00:00.000Z",
  "redirect_from": ["/blog/ive-hit-a-glass-ceiling-of-coding-productivity-now-what/swizec/5191"],
  "categories": "HackerNews, productivity, Programmer, Programming, Twitter, Uncategorized, User interface, yak shaving",
  "hero": "./img/4017-4643421882_95e4d2e573_z.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/koalazymonkey/4643421882/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20150v150h75a1244%201244%200%200075-1l5-3c3-2%204-3%208-3s6-1%209-3c5-3%207-4%2010-1h2l-1-2-1-1-2-1h-2l1-14%201-7v9c0%207%200%209%202%2010h13v1l-6%202-5%202h4c6%200%208%200%2010%202l1%201h1l5%203c3%201%203%202%203%204%200%203%203%202%203-1%201-3%201-3%203-2l2%203c0%202%201%202%2092%202h93V150c0-83%200-149-1-148%200%202-2%203-4%201-1-2-10-2-13-1-1%201-5%200-17-1-4-1-4-1-4%203s0%204-6%201c-6-2-7-3-5-4%201-1-3-1-9-1-10%200-10%200-11%203%200%202-2%203-2%200-1-1-1-1-2%201-1%204-3%201-2-3l-1-1-1%203c-1%203-2%203-3%200l-1-3v3l-1%204-1-4-1-3-1%203c0%203-1%203-3%203-4%200-8-2-8-4-1-2-1-1-1%201l-1%203-1-3c0-2%200-3-1-2%200%203-4%203-5%201s-1-2-1%201v3h-12V0h-15c-10%200-14%200-12%201%201%201%200%201-3%201-3-1-5%200-5%201h-3l-3%202-2%203v1c0%202-4%201-5%200-2-3-4-2-4%200%201%201%201%201%200%200h-3v1l1%202h-13l-2%203v-1l1-4c3-2%200-3-7-2l-9-1c-3-2-5-1-4%203%201%203%201%204-1%203-1-2-10-3-12-1h-1c0-2%202-4%205-4%204%200%203-2-1-4l-4-3-11-1c-14%201-16%201-18%204-2%202-4%201-4-2%200-2-2-2-5%200h-7l-2-2v1c0%201-1%202-3%202s-3-1-3-2l-4-1c-3%200-4%200-4%203-1%204-8%204-8%201%200-2%200-2-1-1-1%203-13%204-17%202h-3c-1%202-3%201-2-2l-1-3-1%202c1%202-3%202-4%200s-1-2-1%201v3H69l-2%201h-1l-1-1-4-1c-3-1-5-2-6-1l-1-1-2-1-2-1c-2-2-15-1-15%201l-3%201c-3%200-8%202-8%203l-3%201c-2%200-2%200-1%201v1l-2-1h-3l-1-2c0-2-4-4-5-3L8%202c1-2%200-3-2-1H4L1%200%200%20150M259%2011l1%202v16c-2%202-12%201-13-1%200-1-1-2-3-1l-2-1c0-1%201-2%202-1l2-1c0-2%201-2-8%200l-9%201v3c2%201%202%202%200%203h-2c0-2-18-1-20%201l-54%203a327%20327%200%2000-58%204l-20%202c-9%200-13%202-9%203l4%201v2c0%202-2%203-2%201l-1-1c-3%200-5%200-5-2l-1-1-1%202c0%201-3%202-6%201-2-1-2%203-3%2019a8743%208743%200%2001-6%2099l1-1%202-1%202-1c1-1%201%201%202%203l-1%206c-1%202-6%203-6%202-1-1-1%200-1%201v2a560%20560%200%2001-8%2077%20485%20485%200%2000116-10%20972%20972%200%2000144-18c37-6%2035-6%2035-7l-11-42a4879%204879%200%2001-42-161l-1-3-7%203c-9%203-8%203-8%200l-1-4h-2M81%20127c-1%202-3%202-8%202H56c-1-3-5-2-6%200-2%203-1%204%202%203%204-1%2012-1%2013%201%202%202%201%204-1%204h-5c-2%202%200%203%205%203a1300%201300%200%20016-3c-2%200-3-1-3-3-1-3-1-3%204-3h5l7-1c6%200%206%200%204-1l-3-1-1-1c0-2-2-1-2%200m66%2021l-2%202%202%201h1l2%201c1-1%202%200%202%201l-8%201c-7%200-8%200-7%201l-1%203c-3%203%200%204%2010%204%209%200%2010%200%2010-2l-1-2-3%201h-3c0-2-3-2-5%200h-2l-2-3c-1-1-1-1%209-1h10-6v-5l-3-1-3-1m-3%2017c-1%202%201%203%208%203l6%201-1%201-1%201c1%201-1%203-5%203-2%200-3-1-3-2l-2%201c-2%202-4%201-4-1-1-4-4-5-5-2-3%204-1%208%203%206h10a1123%201123%200%20018-2v-2l1-2%201-2c1-1%200-1-1-2l-4-1h-6l-3-1c-1-1-2-1-2%201m46%208h-6l-6%201-2%202h2l4%201c-1%201-5%202-18%202h-18c0%204%200%205%201%204%200-1%204-1%205%201h2c0-1%201-2%203-1l5-1c1-2%202-2%202-1h5c5%203%2013%201%2014-3%201-2%202-2%207-2s5%200%204%202l1%202c2-2%202-5%200-6l-3-1h-2m-52%2013c-2%201-3%203-1%205%201%202%202%202%204%201%203-2%207-1%208%200h2c3-1%2011-1%2011%201l-1%201h-1l2%201%201-2c0-2%200-2%204-2%204%201%204%201%203-2%200-3-1-4-2-1-1%202-4%203-5%201h-3l-2-1h-11c-2%201-3%201-3-1-1-2-2-2-6-1m-55%208c0%202-7%202-8%201h-1l-1%201-2-1h-3c-1%201-3%202-6%201l-6%201c-2%201%2016%202%2027%200%204%200%205%200%205%202%201%201%201%201%201-1s1-2%205-2h6c1-1%202%200%202%201%200%202%200%202%201%200l2-2h3c2-1%202-1-6-1H83m54%206c-2%204%202%2010%204%206%201-2%205-2%206%200h6l3-1%202-1%201%201%202%201%202%201%202%201c1%200%202%200%201%202%200%202-4%201-4-1h-1l-6%201h-8c0%204%202%204%208%203h18l3-1%203-1%202-1h-3l-4-1h-1l-2%201c-4%200-4-2%200-2l-2-1c-5-1-5-1-2-1l4-1c1-2-2-4-3-3h-19l-1-1a763%20763%200%2001-5%200c-1-3-4-4-6-1m-95%2020c-2%203-1%207%202%208v-1l-2-3h1c1%201%204%202%205%201l4-1h6c2-1%202-1%202%201l1%203v-5h11l4-1%203%201%203%201%202-1c0-2-5-4-6-3h-8l-2%201H58l-4%201h-3c-1%202-3%201-3-1-1-3-5-3-6-1M3%20289l-1%205c0%204%201%205%203%202h1c1%202%206%202%209%200h6c2-3%201-8-3-8l-2%201h-6l2%201c2%200%202%200%200%201v2c2%200%201%202-1%202-2%201-2%200-2-3%200-5-2-5-2-1l-1%203-1-3c-1-3-2-4-2-2m21%200v8l1-3%201-2%201%203c0%202%200%202%207%202l6-1h2c3%202%205%201%205-4-1-4-4-6-6-3h-1l-2-1c-2%200-2%201-1%204l-1%203c-2%200-2-1-2-3l-1-4-1%204c0%204-3%204-3%200%200-3-4-5-5-3m299%201v4l1%203v-3c0-3%203-4%203%200l1%202h8c2%202%203%201%203-1s0-2%201-1c2%203%203%202%203-2s0-4-1-3c-2%202-5%203-4%201v-1c-1-1-1%200-1%202%200%203%200%203-1%201-1-4-3-5-6-3-1%202-2%202-2%201-1-2-4-2-5%200m42%200v6l1-3c0-4%203-4%203%200%200%203%201%204%204%204l4-1h8c1%202%203%201%203-3%200-6-3-7-3-2%200%204-1%205-1%202s-2-5-4-5c-3%201-2%203%200%202%202%200%202%200%202%202s0%203-3%203c-3-1-4-1-4-4l-1-2a70%2070%200%2001-1%205c0%202-2%201-3-2-1-4-3-5-5-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/90c9416fadcbbcd8ce55316e010590a9/ca0a1/4017-4643421882_95e4d2e573_z.webp 223w", "/static/90c9416fadcbbcd8ce55316e010590a9/75680/4017-4643421882_95e4d2e573_z.webp 445w", "/static/90c9416fadcbbcd8ce55316e010590a9/0ba47/4017-4643421882_95e4d2e573_z.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/90c9416fadcbbcd8ce55316e010590a9/853b2/4017-4643421882_95e4d2e573_z.jpg 223w", "/static/90c9416fadcbbcd8ce55316e010590a9/0a4fe/4017-4643421882_95e4d2e573_z.jpg 445w", "/static/90c9416fadcbbcd8ce55316e010590a9/c08c5/4017-4643421882_95e4d2e573_z.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/90c9416fadcbbcd8ce55316e010590a9/c08c5/4017-4643421882_95e4d2e573_z.jpg",
                "alt": "Productivity, by koalazymonkey",
                "title": "Productivity, by koalazymonkey",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Productivity, by koalazymonkey`}</figcaption>{`
  `}</figure></a></p>
    <p>{`As a budding `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Programmer",
        "title": "Programmer"
      }}>{`programmer`}</a>{`, I could spend an hour programming and within that hour I learned so much the next hour was like three sets of the first combined.`}</p>
    <p>{`Productivity grew exponentially with no sign of stopping. When the growth slowed, I would discover a new set of tools, a new framework or even a whole new language and my productivity would take a jerk, a stutter, jump around and make a massive leap forward.`}</p>
    <p>{`With a bit of smoothing you'd still get a roughly `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Exponential_growth",
        "title": "Exponential growth"
      }}>{`exponential curve`}</a>{`.`}</p>
    <p>{`As Ralph W. Sockman, whomever he is, once said `}<em parentName="p">{`"The larger the island of knowledge, the longer the shoreline of wonder."`}</em></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/53b1469db0e18a0caf434ff1880fa8f8/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M179%209c-16%203-34%209-48%2017-11%206-32%2022-31%2024l7-5c54-47%20132-47%20186%200l7%205c1-2-19-18-30-24-27-15-62-21-91-17M88%2062L72%2088a142%20142%200%200027%20161l-5-7a141%20141%200%2001-9-173c6-8%207-11%203-7m221-2l6%209c37%2052%2033%20127-9%20173l-5%207%204-4a141%20141%200%20004-185m-57%2035c-8%204-23%2013-30%2020l-3%202-5-2c-4-2-7-2-14-2-40%200-52%2053-16%2070%2028%2014%2061-14%2052-43l-2-4%2010-10c17-17%2025-29%2022-33-2-2-8-1-14%202M103%20254c11%2011%2035%2026%2052%2031%2029%209%2061%209%2090%200%209-3%2028-12%2036-18%208-5%2020-17%2020-18l-7%205c-52%2048-136%2048-188%200-7-6-9-7-3%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53b1469db0e18a0caf434ff1880fa8f8/ca0a1/articles-phd-school-in-pictures-images-PhDKnowledge.005.webp 223w", "/static/53b1469db0e18a0caf434ff1880fa8f8/75680/articles-phd-school-in-pictures-images-PhDKnowledge.005.webp 445w", "/static/53b1469db0e18a0caf434ff1880fa8f8/8d1ba/articles-phd-school-in-pictures-images-PhDKnowledge.005.webp 890w", "/static/53b1469db0e18a0caf434ff1880fa8f8/a9a89/articles-phd-school-in-pictures-images-PhDKnowledge.005.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53b1469db0e18a0caf434ff1880fa8f8/853b2/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg 223w", "/static/53b1469db0e18a0caf434ff1880fa8f8/0a4fe/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg 445w", "/static/53b1469db0e18a0caf434ff1880fa8f8/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg 890w", "/static/53b1469db0e18a0caf434ff1880fa8f8/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/53b1469db0e18a0caf434ff1880fa8f8/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.005.jpg",
                "alt": "Experience deepens a specialty",
                "title": "Experience deepens a specialty",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Experience deepens a specialty`}</figcaption>{`
  `}</figure></p>
    <p>{`When my knowledge wasn't very vast, the increasing wonder only meant there were more things I could explore. pushing in one direction only showed a whole bunch of new and cool stuff that I could explore to become even better. Life was grand. And simple!`}</p>
    <p>{`But lately this has stopped happening. I get almost exactly linear returns on the time I invest, sometimes even sublinear. It seems that no matter what new tool I add to my arsenal, productivity isn't affected very much. Learning the new tool barely makes up for the time invested into learning rather than doing from scratch.`}</p>
    <h2 {...{
      "id": "a-ceiling"
    }}>{`A ceiling`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a8a972011001bf319bafe0f0c3e2622c/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M176%2010a145%20145%200%2000-76%2040l7-5c53-47%20133-47%20186%200l7%205-5-6c-32-28-77-41-119-34m124%2041l3%203%202%203-3%201c-11%202-34%2017-62%2041l-21%2018-6-2c-10-5-28-2-37%206a37%2037%200%20008%2062c28%2014%2061-13%2052-43l-2-5%206-5%209-8a237%20237%200%200059-62v-3l-8-6M88%2062L72%2088c-25%2052-16%20114%2023%20157l4%204-3-5A141%20141%200%200185%2069c6-8%207-11%203-7m221-2l6%209a142%20142%200%2001-14%20180l4-4c18-19%2030-44%2035-70%202-13%202-41-1-54a121%20121%200%2000-30-61M106%20256c24%2023%2057%2035%2094%2035a135%20135%200%2000101-42l-7%205c-52%2048-136%2048-188%200l-7-5%207%207\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a8a972011001bf319bafe0f0c3e2622c/ca0a1/articles-phd-school-in-pictures-images-PhDKnowledge.006.webp 223w", "/static/a8a972011001bf319bafe0f0c3e2622c/75680/articles-phd-school-in-pictures-images-PhDKnowledge.006.webp 445w", "/static/a8a972011001bf319bafe0f0c3e2622c/8d1ba/articles-phd-school-in-pictures-images-PhDKnowledge.006.webp 890w", "/static/a8a972011001bf319bafe0f0c3e2622c/a9a89/articles-phd-school-in-pictures-images-PhDKnowledge.006.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a8a972011001bf319bafe0f0c3e2622c/853b2/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg 223w", "/static/a8a972011001bf319bafe0f0c3e2622c/0a4fe/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg 445w", "/static/a8a972011001bf319bafe0f0c3e2622c/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg 890w", "/static/a8a972011001bf319bafe0f0c3e2622c/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a8a972011001bf319bafe0f0c3e2622c/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.006.jpg",
                "alt": "Hacking takes you to the edge of knowledge",
                "title": "Hacking takes you to the edge of knowledge",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Hacking takes you to the edge of knowledge`}</figcaption>{`
  `}</figure></p>
    <p>{`For example, I just finished a very simple project for a friend:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`import some schedule data from excel to postgre
s`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`web interface to view class schedule`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`web interface to change schedules`}</p>
      </li>
    </ul>
    <p>{`Simple right?`}</p>
    <p>{`With the many years of writing python scripts, plenty of experience in data munging and countless web interfaces under my belt, this project should be a walk in the park. Considering I could do it in my sleep, it definitely shouldn't be more than an afternoon's worth of work.`}</p>
    <p>{`It took `}<strong parentName="p">{`20 hours`}</strong>{`.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2026c0%202%204%203%2015%208%2063%2026%20117%2063%20165%20112l13%2014h-4c-34%208-93%2044-168%20105L0%20281v19h99l18-18a437%20437%200%200085-108%20488%20488%200%200181%20126h2a500%20500%200%2000-45-85A497%20497%200%20000%2026\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/ca0a1/articles-phd-school-in-pictures-images-PhDKnowledge.008.webp 223w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/75680/articles-phd-school-in-pictures-images-PhDKnowledge.008.webp 445w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/8d1ba/articles-phd-school-in-pictures-images-PhDKnowledge.008.webp 890w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/a9a89/articles-phd-school-in-pictures-images-PhDKnowledge.008.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/853b2/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg 223w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/0a4fe/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg 445w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg 890w", "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f4b9f3c9eb1af02a60f3d5dfd247a69d/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.008.jpg",
                "alt": "You push very hard at the boundary",
                "title": "You push very hard at the boundary",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`You push very hard at the boundary`}</figcaption>{`
  `}</figure></p>
    <p>{`And no, that's not because I spent so much time checking `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`Twitter`}</a>{`, `}<a parentName="p" {...{
        "href": "http://reddit.com/",
        "title": "Reddit"
      }}>{`Reddit`}</a>{`, `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`HackerNews`}</a>{`, `}<a parentName="p" {...{
        "href": "http://facebook.com",
        "title": "Facebook"
      }}>{`Facebook`}</a>{` and email. I optimized those problems out of my work time when I started using `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859",
        "title": "Living life in 25min increments"
      }}>{`the pomodoro technique`}</a>{` about a year ago. A `}<em parentName="p">{`huge`}</em>{` boon to productivity.`}</p>
    <p>{`Sure, I was forced to use a web framework I've never used before - Bottle. I reckon it added two hours to development time, it's really very very simple. Learning Bottle was on the level of learning a new syntax for Django.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1d7c262740ae597b9285fe979131f8f3/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2026c0%202%204%203%2015%208%2063%2026%20117%2063%20165%20112l13%2014h-4c-34%208-93%2044-168%20105L0%20281v19h99l18-18a437%20437%200%200085-108c0-4%202-3%2017%2017a489%20489%200%200164%20109c2%200%203%201-1-7a603%20603%200%2000-75-125c2-2%201-8-1-10s-3-2-6-2c-4%201-4%201-19-15A492%20492%200%20000%2026\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d7c262740ae597b9285fe979131f8f3/ca0a1/articles-phd-school-in-pictures-images-PhDKnowledge.009.webp 223w", "/static/1d7c262740ae597b9285fe979131f8f3/75680/articles-phd-school-in-pictures-images-PhDKnowledge.009.webp 445w", "/static/1d7c262740ae597b9285fe979131f8f3/8d1ba/articles-phd-school-in-pictures-images-PhDKnowledge.009.webp 890w", "/static/1d7c262740ae597b9285fe979131f8f3/a9a89/articles-phd-school-in-pictures-images-PhDKnowledge.009.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d7c262740ae597b9285fe979131f8f3/853b2/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg 223w", "/static/1d7c262740ae597b9285fe979131f8f3/0a4fe/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg 445w", "/static/1d7c262740ae597b9285fe979131f8f3/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg 890w", "/static/1d7c262740ae597b9285fe979131f8f3/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1d7c262740ae597b9285fe979131f8f3/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.009.jpg",
                "alt": "You release an opensource thingy",
                "title": "You release an opensource thingy",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`You release an opensource thingy`}</figcaption>{`
  `}</figure></p>
    <p>{`Easy.`}</p>
    <p>{`The HTML/CSS usually takes a while for such projects, but I used Bootstrap. Completely stock. Almost no modifications. That wasn't an issue either.`}</p>
    <p>{`And yet, a project requiring barely any thinking, where I wasn't doing any `}<a parentName="p" {...{
        "href": "http://en.wiktionary.org/wiki/yak_shaving"
      }}>{`Yak Shaving`}</a>{` and the budget was definitely too tight to `}<a parentName="p" {...{
        "href": "http://xkcd.com/554/"
      }}>{`write the HTML in haiku`}</a>{` ... still took 20 hours. That's just too much.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/328eeb20616ad2976f5ed5e5af7adaa6/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M176%2010c-18%203-38%2011-52%2020-8%205-5%205%203%200%2045-27%20101-27%20146%200%208%205%2011%205%203%200-28-18-67-26-100-20m125%2042l3%203a143%20143%200%200115%20172l10-18c21-45%2016-98-11-138a266%20266%200%2001-10-15l-4-3-3-1M88%2062L72%2088a143%20143%200%200010%20140l-3-7A142%20142%200%200191%2061l-3%201m64%20221a147%20147%200%200095%200l-7%202c-24%207-56%207-79%200l-9-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/328eeb20616ad2976f5ed5e5af7adaa6/ca0a1/articles-phd-school-in-pictures-images-PhDKnowledge.012.webp 223w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/75680/articles-phd-school-in-pictures-images-PhDKnowledge.012.webp 445w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/8d1ba/articles-phd-school-in-pictures-images-PhDKnowledge.012.webp 890w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/a9a89/articles-phd-school-in-pictures-images-PhDKnowledge.012.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/328eeb20616ad2976f5ed5e5af7adaa6/853b2/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg 223w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/0a4fe/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg 445w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg 890w", "/static/328eeb20616ad2976f5ed5e5af7adaa6/72e01/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/328eeb20616ad2976f5ed5e5af7adaa6/7f80b/articles-phd-school-in-pictures-images-PhDKnowledge.012.jpg",
                "alt": "But in the grand scale of things ...",
                "title": "But in the grand scale of things ...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`But in the grand scale of things ...`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "many-questions"
    }}>{`Many questions`}</h2>
    <p>{`I don't have an answer, but I do have a question: What's a guy to do when/if this glass ceiling is reached? Make sure to pick tougher projects? Learn ever more tools, but with diminishing returns? Concede that some things just take time and give up?`}</p>
    <p>{`If I'm a 1x programmer, how do I become a 5x programmer? At least a 2x one? If I happen to be a 10x programmer, how do I become a 100x programmer? How do I even find out how much X programmer I am?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://programmers.blogoverflow.com/2012/08/20-controversial-programming-opinions/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_25_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://programmers.blogoverflow.com/2012/08/20-controversial-programming-opinions/"
        }}>{`20 controversial programming opinions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://vivianesview.wordpress.com/2012/08/30/staring-at-the-ceiling-can-be-fun-at-lest-when-its-the-ceiling-of-a-yurt-in-mongolia/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/109435301_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://vivianesview.wordpress.com/2012/08/30/staring-at-the-ceiling-can-be-fun-at-lest-when-its-the-ceiling-of-a-yurt-in-mongolia/"
        }}>{`staring at the ceiling can be fun - at least when it's the ceiling of a yurt in Mongolia`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.splunk.com/2012/07/05/splunkbot-node-js-irc-and-the-javascript-sdk-for-fun-and-profit-pt-2/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/98588264_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blogs.splunk.com/2012/07/05/splunkbot-node-js-irc-and-the-javascript-sdk-for-fun-and-profit-pt-2/"
        }}>{`Splunkbot: Node.js, IRC, and the JavaScript SDK for Fun and Profit pt. 2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cooper.com/journal/2012/08/the-best-interface-is-no-interface.html/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_29_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cooper.com/journal/2012/08/the-best-interface-is-no-interface.html/"
        }}>{`The best interface is no interface`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eskills4future.wordpress.com/2012/08/27/programmers-what-do-you-really-do/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/109032168_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://eskills4future.wordpress.com/2012/08/27/programmers-what-do-you-really-do/"
        }}>{`Hey programmers! What do you really do?`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=08bc5ae9-5767-4b42-b3d8-fd8564f68900",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      